import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { keys } from '@clubhub/constants';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import {
  DisclaimerContentLenderHubComponent,
} from '@shared/components/disclaimer-content-lenderhub/disclaimer-content-lenderhub.component';
import { ClientApps } from '@shared/models';
import { AuthorizeService, ModalStateService } from '@shared/services';
import { DisclaimerService } from '@shared/services/disclaimer.service';
import { DisclaimerContentIgniteComponent } from '../disclaimer-content-ignite/disclaimer-content-ignite.component';

@Component({
  selector: 'lib-disclaimer-modal',
  templateUrl: 'disclaimer-modal.component.html',
  styleUrls: ['disclaimer-modal.component.scss'],
  imports: [DisclaimerContentLenderHubComponent, DisclaimerContentIgniteComponent],
})
export class DisclaimerModalComponent {
  private readonly state = inject(ModalStateService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly disclaimerService = inject(DisclaimerService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthorizeService);

  public form = new UntypedFormGroup({});
  public fields: FormlyFieldConfig[] = [];

  public formOptions: FormlyFormOptions = {};
  public isDisabled = true;

  public yes() {
    if (this.options?.client) {
      this.disclaimerService.setDisclaimerAsRead(this.options.client).subscribe(() => {
        sessionStorage.setItem(keys.termsDisclaimer, 'true');
        this.state.topmostModal?.close('confirmed');
        if (this.state.modalStack?.length > 0) {
          this.state.modal = this.state.topmostModal;
        }
      });
    }
  }

  public cancel() {
    this.state.topmostModal?.dismiss('not confirmed');
    if (this.state.modalStack?.length > 0) {
      this.state.modal = this.state.topmostModal;
    }
    this.router.navigate(['/']);
  }

  public get options() {
    return this.state.options;
  }

  public get isClubHub(): boolean {
    return this.options?.client === ClientApps.ClubHub;
  }

  public get isLenderHub(): boolean {
    return this.options?.client === ClientApps.LenderHub;
  }

  public get isIgnite(): boolean {
    return this.authService.isIgniteApp;
  }

  public onScroll(event: any) {
    const distanceFromBottom = 120;
    if (this.isDisabled && event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - distanceFromBottom) {
      this.isDisabled = false;
      this.changeDetectorRef.detectChanges();
    }
  }
}
